<div class="calendar-modal-confirmation">
  <h2 mat-dialog-title>Confirmation</h2>
  <mat-dialog-content class="mat-typography">
    <p><span [innerHTML]="message"></span></p>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Annuler</button>
    <button mat-button [mat-dialog-close]="data" color="warn">Supprimer</button>
  </mat-dialog-actions>
</div>